export enum SubscriptionPlanTabsEnums {
  plans = 'plans',
  singlePlan = 'singlePlan',
  payment = 'payment'
}
